import 'moment/locale/fi';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { toast } from 'react-toastify';
import Modal from 'react-responsive-modal';
import Loader from 'react-loader';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { requestServiceSite } from '../actions/destination';
import { requestAckIssue } from '../actions/issue';
import { enableSubNavbar, setSubNavbar } from '../actions/navbar';
import {
  getLocalizedString,
  getLocalizedDateWithWeekday,
  getLocalizedTime,
  getLocalizedDateTime, getLocalizedName,
} from '../localization/LocalizedString';
import './ServiceSite.css';
import Instructions from '../components/instructions/Instructions';
import ManualTask from '../components/servicesite/ManualTask';
import UpdateTask from '../components/servicesite/UpdateTask';
import ManualIssue from '../components/servicesite/ManualIssue';
import Button from '../components/forms/Button';
import {
  downloadFile,
  createImageFromBase64,
  installationDocumentImagesRequestApi,
} from '../actions/helper';

let startDate = new Date();
let endDate = new Date();

const secondsToMinutes = (seconds) => {
  let timer = `${Math.floor(seconds / 60)}:`;

  const secs = seconds % 60;
  if (secs < 10) {
    timer += '0';
  }
  timer += secs;

  return timer;
};

const AdditionalFeatures = {
  DATAPICK: 'DATAPICK',
  INSTALLATIONDOCUMENT: 'INSTALLATIONDOCUMENT',
  DELIVERY: 'DELIVERY',
};

class ServiceSite extends React.Component {
  VIEW_TYPE = Object.freeze({
    history: Symbol(),
    new_task: Symbol(),
    new_issue: Symbol(),
    update_task: Symbol(),
  });

  constructor(props) {
    super(props);
    this.state = {
      activeView: this.VIEW_TYPE.history,
      from: null,
      to: null,
      fromDisable: undefined,
      modalIssue: null,
      installationDocumentModalOpen: false,
      timelineIndex: 5,
      taskToUpdate: null,
      imageData: null,
      currentInstallationDocumentModalId: null,
      installationDocumentLoading: true,
      isDataLoading: false,
    };
  }

  componentDidMount() {
    const { serviceSite } = this.props;

    if (this.updateNavbar(serviceSite)) {
      this.refreshSites();
    }
  }

  componentDidUpdate(prevProps) {
    const { serviceSite: currentServiceSite } = prevProps;
    const { serviceSite } = this.props;

    this.updateNavbar(serviceSite, currentServiceSite);
  }

  handleFromChange = (date) => {
    if (!date) {
      this.setState({ from: null, fromDisable: undefined });
      return;
    }

    const today = moment().endOf('day');
    const from = moment.min(moment(date).startOf('day'), moment().startOf('day'));
    const fromDisable = moment.min(moment(from).add(6, 'months').endOf('day'), today);
    let to = this.state.to ? moment(this.state.to).endOf('day') : moment(fromDisable);

    if (to.isBefore(from)) to = moment(from).endOf('day');
    if (to.isAfter(fromDisable)) to = moment(fromDisable);

    this.setState({
      from: from.toDate(),
      to: to.toDate(),
      fromDisable: fromDisable.toDate(),
    });
  };

  handleToChange = (date) => {
    if (!date) {
      this.setState({ to: null });
      return;
    }

    const { from, fromDisable } = this.state;
    const minimumTo = moment(from).endOf('day');
    const maximumTo = moment(fromDisable || new Date()).endOf('day');
    let to = moment(date).endOf('day');

    if (to.isBefore(minimumTo)) to = minimumTo;
    if (to.isAfter(maximumTo)) to = maximumTo;

    this.setState({ to: to.toDate() });
  };

  onDataError = () => {
    this.setState({
      isDataLoading: false,
    });
  };

  onDataSuccess = () => {
    this.setState({
      isDataLoading: false,
    });
  };

  refreshSites() {
    const { requestServiceSite, serviceSiteId } = this.props;

    endDate = new Date();
    startDate = new Date(endDate - (3600 * 1000 * 24 * 30));

    this.setState({
      isDataLoading: true,
    });
    requestServiceSite(serviceSiteId, startDate, endDate, this.onDataError, this.onDataSuccess);
  }

  changeView = (viewType) => () => {
    this.setState({
      activeView: viewType,
    });
  };

  changeTaskToUpdate = (task) => () => {
    console.log('set task update');
    this.setState({
      taskToUpdate: task,
      activeView: this.VIEW_TYPE.update_task,
    });
  };

  clearTaskToUpdate = () => () => {
    console.log('set task update');
    this.setState({
      taskToUpdate: null,
      activeView: this.VIEW_TYPE.history,
    });
  };

  onTaskSaved = () => {
    this.changeView(this.VIEW_TYPE.history)();
    const { translate } = this.props;
    toast(translate('new_task.save_ok'));
    this.refreshSites();
  };

  onIssueSaved = () => {
    this.changeView(this.VIEW_TYPE.history)();
    const { translate } = this.props;
    toast(translate('new_issue.save_ok'));
    this.refreshSites();
  };

  updateNavbar(serviceSite, currentServiceSite) {
    const { setSubNavbar, currentLanguage } = this.props;
    const { destinationId = '' } = this.props;

    const {
      id, serviceSiteId, name, isPartial,
    } = serviceSite;

    if (currentServiceSite !== undefined && id === currentServiceSite.id) {
      return false;
    }
    const urlPathParts = window.location.href.split('/');
    const sourcePath = urlPathParts[urlPathParts.length - 1];
    if (!id) {
      setSubNavbar({
        backLink: `/destination/${destinationId}/${sourcePath}`,
      });

      return true;
    }

    setSubNavbar({
      backLink: `/destination/${destinationId}/${sourcePath}`,
      title: [
        serviceSiteId,
        getLocalizedString(name, currentLanguage),
      ],
    });

    return isPartial;
  }

  groupTimelineItems(tasks, issues) {
    const groups = {};

    const addGroupData = (time, renderer, data) => {
      const key = new Date(time.valueOf()).setHours(0, 0, 0, 0);

      if (!(key in groups)) {
        groups[key] = {
          totalDuration: 0,
          latestTask: null,
          hasIssues: false,
          items: [],
        };
      }

      groups[key].items.push({
        time,
        renderer,
        data,
      });

      return groups[key];
    };

    (tasks || []).forEach((task) => {
      const time = new Date(task.totalEndTime);

      const group = addGroupData(time, this.renderTaskItem, task);
      group.totalDuration += task.totalDuration;
      if (!group.latestTask || time > group.latestTask) {
        group.latestTask = time;
      }
    });

    (issues || []).forEach((issue) => {
      const time = issue.timestamp ? issue.timestamp : new Date(issue.createdAt);
      // const time = new Date(issue.createdAt);
      const group = addGroupData(time, this.renderIssueItem, issue);

      if (!issue.acked) {
        group.hasIssues = true;
      }
    });

    for (const groupKey in groups) {
      groups[groupKey].items.sort((a, b) => {
        if (a.time < b.time) {
          return 1;
        } if (b.time < a.time) {
          return -1;
        }
        return 0;
      });
    }

    const groupOrder = Object.keys(groups).sort((a, b) => Number.parseInt(b, 10) - Number.parseInt(a, 10));

    const timelineGroups = [];

    groupOrder.forEach((groupKey) => {
      timelineGroups.push({
        date: new Date(Number.parseInt(groupKey, 10)),
        ...groups[groupKey],
      });
    });

    return timelineGroups;
  }

  renderTaskItem = (task) => {
    const { currentLanguage, session: { isAdmin = false }, translate } = this.props;
    const { taskId, service: { name, additionalFeatures }, installationDocuments } = task;
    const attrs = {
      key: `task-${taskId}`,
      className: `timeline-item task-item${!!isAdmin && !task.billed ? ' clickable' : ''}`,
      onClick: (!!isAdmin && !task.billed ? this.changeTaskToUpdate(task) : undefined),
    };

    let addFeatureStr = '';
    addFeatureStr += Array.from(additionalFeatures)
      .join(',')
      .toLowerCase();
    const taskIncludesInstallationDocument = additionalFeatures.includes(AdditionalFeatures.INSTALLATIONDOCUMENT);

    return (
      <div>
        <div {...attrs}>
          <div
            className="text-4">
            {getLocalizedString(name, currentLanguage)}
            {' '}
            {(addFeatureStr !== 'none') ? ` (${addFeatureStr})` : ''}
            {!!isAdmin && !task.billed
            && (
            <span>
              <h5
              className="additional-info-color">
                {translate('update_task_modal.modify')}
                {' '}
                &raquo;
              </h5>
            </span>
            )}
          </div>
        </div>
        <div className="timeline-item-installation-document">
          {!!taskIncludesInstallationDocument && Array.isArray(installationDocuments) && installationDocuments.length !== 0
          && (
          <div
            className="text-4">
            {
            installationDocuments.map((value, index) => (
              <div>
                <div>
                  <p className="timeline-text-plain">
                    {Array.from(new Set(installationDocuments[index].shipmentIds))
                      .join(', ')}
                  </p>
                  <button
                    className="form-button-service-history-installation-document"
                    onClick={() => {
                      this.showInstallationDocumentModal(installationDocuments[index].id);
                    }}>
                    <h5
                      className="additional-info-color h5-top-margin">
                      {translate('issue_show_more')}

                      &raquo;
                    </h5>
                  </button>
                </div>
              </div>
            ))
}
          </div>
          )}
        </div>
      </div>
    );
  };

  fetchImages = (id) => {
    installationDocumentImagesRequestApi(`/installationdocument/images/${id}`)
      .then((imageData) => {
        if (imageData != null) {
          this.setState({
            imageData,
          });
        } else {
          this.setState({ installationDocumentLoading: false });
        }
      });
  };

  showInstallationDocumentModal = (id) => {
    this.fetchImages(id);
    this.setState({
      installationDocumentModalOpen: true,
      currentInstallationDocumentId: id,
    });
  };

  closeInstallationDocumentModal = () => {
    this.setState({
      imageData: null,
      currentInstallationDocumentId: null,
      installationDocumentModalOpen: false,
      installationDocumentLoading: true,
    });
  };

  renderInstallDocModal = () => {
    const { translate, currentLanguage } = this.props;
    const { imageData, currentInstallationDocumentId: id, installationDocumentModalOpen: modalOpen } = this.state;
    const { serviceSite: { tasks } = {} } = this.props;

    let pdfName;
    if (tasks !== undefined) {
      tasks.filter((task) => {
        if (task.installationDocuments.length > 0) {
          task.installationDocuments.filter((installationDocument) => {
            if (installationDocument.id === id) {
              if (installationDocument.customer !== undefined) {
                pdfName = installationDocument.customer.pdfName;
              }
            }
          });
        }
      });
    }
    const modalStyles = {
      modal: {
        minWidth: '400px',
        minHeight: '400px',
        padding: '2rem',
        maxHeight: '90vh',
        overflowY: 'auto',
      },
    };

    const imageStyles = {
      paddingBottom: '10px',
      objectFit: 'contain',
      maxHeight: '600px',
      width: '100%',
      height: '100%',
    };

    const options = {
      lines: 13,
      length: 14,
      width: 7,
      radius: 21,
      scale: 1.00,
      corners: 1,
      color: '#000',
      opacity: 0.25,
      rotate: 0,
      direction: 1,
      speed: 1,
      trail: 60,
      fps: 20,
      position: 'relative',
    };

    return (
      <div>
        <Modal open={modalOpen}
               onClose={this.closeInstallationDocumentModal}
               little
               showCloseIcon
               styles={modalStyles}
               center>
          <div className="issue-item">
            <h2
              className="first-uppercase bold">
              {translate('service_report.search.type_installationDocument')}
            </h2>
            {pdfName !== undefined && (
            <button onClick={() => {
              downloadFile(pdfName, '/installationdocument/report/pdf');
            }}
                    className="form-button-small form-input-shadow">
              {translate('service_report.column_task.downloadPDF')}
            </button>
            )}
            <button type="button"
                    className="close"
                    aria-label="Close"
                    onClick={this.closeInstallationDocumentModal} />
            <div className="installation-document-image-div">
              {(Array.isArray(imageData) && imageData.length !== 0) ? imageData.map((item) => (
                <div>
                  <h3>{getLocalizedName(item, currentLanguage)}</h3>
                  {item.imageList.map((image) => (
                    <img alt=""
                         src={createImageFromBase64(image)}
                         style={imageStyles} />
                  ))}
                </div>
              ))
                : (
                  <div>
                    {this.state.installationDocumentLoading
                      ? (
                        <div className="installation-document-loader">
                          <Loader loaded={false} options={options} />
                        </div>
                      )
                      : (
                        <h4
                      className="primary-color">
                          {translate('new_task.could_not_load_images')}
                        </h4>
                      )}
                  </div>
                )}
            </div>
          </div>
        </Modal>
      </div>

    );
  };

  renderIssueItem = (issue) => {
    const { translate, currentLanguage, session: { isAdmin = false } } = this.props;
    const {
      id, type, description, ack,
    } = issue;

    const attrs = {
      key: `issue-${id}`,
      className: `timeline-item ${
        isAdmin
          ? `issue-item${ack ? ' issue-acked' : ''} clickable`
          : 'issue-item-black'
      }`,
      onClick: (isAdmin ? this.showIssueDetails(issue) : undefined),
    };

    let desciriptionClass = 'identifier-color-black';
    if (!ack && isAdmin) {
      desciriptionClass = 'alert-color';
    } else if (ack && isAdmin) {
      desciriptionClass = 'identifier-color';
    }

    return (
      <div {...attrs}>
        <div className="text-4">
          <div className={desciriptionClass}>
            {translate('issue')}
            (
            {getLocalizedString(type, currentLanguage)}
            )
          </div>
          {!!isAdmin
            && <div className={desciriptionClass}>{description}</div>}
          {!!ack && !!isAdmin
            && <div className="text-5 normal-color">{translate('issue_acked')}</div>}
          {!!isAdmin
            && (
            <h5 className="additional-info-color">
              {translate('issue_show_more')}
              {' '}
              &raquo;
            </h5>
            )}
        </div>
      </div>
    );
  };

  showIssueDetails = (issue) => () => {
    this.setState({ modalIssue: issue });
  }

  closeIssueDetails = () => {
    this.setState({ modalIssue: null });
  }

  ackIssue = (id) => {
    const { requestAckIssue, translate } = this.props;
    return () => {
      requestAckIssue(
        id,
        (e) => {
          console.log(e);
          toast.error(translate('issue_ack_error'));
        },
        () => {
          this.closeIssueDetails();
          toast(translate('issue_ack_ok'));
          this.refreshSites();
        },
      );
    };
  }

  renderModal() {
    const { translate, currentLanguage } = this.props;
    const { modalIssue: issue } = this.state;
    const {
      id, type, description, mediaIds, mediaId, userId, createdAt, ack,
    } = issue || {};
    const mediaUrl = !this.isEmpty(mediaIds) ? mediaIds.map((imageId) => `/api/media/${imageId}`) : (!this.isEmpty(mediaId) ? [`/api/media/${mediaId}`] : null);

    const modalStyles = {
      modal: {
        minWidth: '400px',
        padding: '2rem',
        maxHeight: '90vh',
        overflowY: 'auto',
      },
    };
    const imageStyles = {
      paddingBottom: '10px',
      objectFit: 'contain',
      maxHeight: '600px',
      width: '100%',
      height: '100%',
    };

    const time = createdAt ? getLocalizedTime(new Date(createdAt), currentLanguage) : '';
    const ackUI = ack ? (
      <div>
        <h5>
          {translate('issue_ack_time')}
          :

          {getLocalizedDateTime(new Date(ack.timestamp), currentLanguage)}
        </h5>
        <h5>
          {translate('issue_ack_user')}
          :

          {ack.userId}
        </h5>
      </div>
    ) : (
      <Button style={{ margin: '20px 0px 0px 0px', width: '200px' }} onClick={this.ackIssue(id)}>{translate('issue_ack')}</Button>
    );

    return (
      <Modal open={issue != null} onClose={this.closeIssueDetails} little showCloseIcon={false} styles={modalStyles} center>
        <div className="issue-item">
          <button type="button"
                  className="close"
                  aria-label="Close"
                  onClick={this.closeIssueDetails}
                  style={{ float: 'right' }}>
            <span aria-hidden="true">&times;</span>
          </button>
          <h5>
            {translate('issue')}
               &nbsp;(
            {getLocalizedString(type, currentLanguage)}
            )
          </h5>
          <h5>
            {translate('issue_created')}
            :

            {time}
          </h5>
          <h5>
            {translate('issue_creator')}
            :

            {userId}
          </h5>
          <h5>
            {translate('issue_message')}
            :
          </h5>
          <div style={{ marginTop: '1.5em', whiteSpace: 'pre-line' }}>{description}</div>
          <div>
            {ackUI}
          </div>
        </div>

        {!!mediaUrl
          && mediaUrl.map((imageUrl) => (
            <a href={imageUrl} target="_blank" rel="noreferrer">
              <img src={imageUrl} alt="" style={imageStyles} />
            </a>
          ))}
      </Modal>
    );
  }

  isEmpty(str) {
    return (!str || str.length === 0);
  }

  getTimerString(seconds) {
    let timer = `${Math.floor(seconds / 60)}:`;

    seconds %= 60;
    if (seconds < 10) {
      timer += '0';
    }
    timer += seconds;

    return timer;
  }

  renderTimelineDateGroup = (dateGroup) => {
    const { translate, currentLanguage, session: { isAdmin = false } } = this.props;

    return (
      <div className="timeline-container" key={dateGroup.date}>
        <div className={`timeline-content ${dateGroup.hasIssues && isAdmin ? 'timeline-alert' : ''}`}>
          <h2 className="first-uppercase">{getLocalizedDateWithWeekday(dateGroup.date, currentLanguage)}</h2>

          {!!dateGroup.latestTask
            && (
            <h4 className="first-uppercase">
              {translate('service_finished_at')}
              {' '}
              {getLocalizedTime(dateGroup.latestTask, currentLanguage)}
              ,
              {' '}
              {translate('service_total_duration')}
              {' '}
              {secondsToMinutes(dateGroup.totalDuration)}
              {' '}
            </h4>
            )}

          {dateGroup.items.map((item) => item.renderer(item.data))}
        </div>
      </div>
    );
  }

  renderTimeline() {
    const { serviceSite: { tasks, issues, isPartial } = {} } = this.props;
    if (isPartial) return null;

    const timelineGroups = this.groupTimelineItems(tasks, issues);

    return (
      <div className="text-5">
        <div className="timeline">
          {timelineGroups.map(this.renderTimelineDateGroup)}
        </div>
      </div>
    );
  }

  showMoreTimeline = (e) => {
    e.preventDefault();
    const { from, to } = this.state;
    const { requestServiceSite, serviceSiteId } = this.props;

    this.setState({
      isDataLoading: true,
    });

    requestServiceSite(serviceSiteId, from, to, this.onDataError, this.onDataSuccess);
  }

  showInitialTimeLine = () => {
    let { from, to } = this.state;
    const { requestServiceSite, serviceSiteId } = this.props;

    if (from === null && to === null) {
      from = new Date(endDate - (3600 * 1000 * 24 * 30));
      to = new Date(endDate);

      this.setState({
        from,
        to,
      });
    }
    requestServiceSite(serviceSiteId, from, to, this.onDataError(), this.onDataSuccess());
  }

  renderHistoryView() {
    const { translate, currentLanguage, session: { isAdmin = false } } = this.props;
    const {
      from, to, fromDisable, isDataLoading,
    } = this.state;
    const title = isDataLoading
      ? translate('service_report.search.loading')
      : translate('service_report.search.btn');

    if (from === null && to === null) {
      this.showInitialTimeLine();
    }

    let adminActions;

    if (isAdmin || !isAdmin) {
      adminActions = (
        <div className="text-5 timeline-margin-left-35">
          <div className="history-view-button">
            <Button className="secondary service-site-width-filter" onClick={this.changeView(this.VIEW_TYPE.new_task)}>{translate('new_task.title')}</Button>
          </div>
          <div className="history-view-button timeline-right-button-margin">
            <Button className="secondary service-site-width-filter" onClick={this.changeView(this.VIEW_TYPE.new_issue)}>{translate('new_issue.title')}</Button>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="row">
          <div className="col-sm-12 timeline-header-margin">
            <h1>{translate('service_history')}</h1>
          </div>
        </div>
        {adminActions}
        <div className="row">
          <div className="col-sm-12">
            <div className="timeline-margin-left-35">
              <form style={{ display: 'inline-block' }} onSubmit={this.showMoreTimeline}>
                <div className="history-view-button">
                  <DatePicker
                    className="app-date-picker-input service-site-width-filter"
                    selected={from || new Date()}
                    onChange={this.handleFromChange}
                    dateFormat={['dd.MM.yyyy', 'd.M.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']}
                    strictParsing
                    maxDate={new Date()}
                    locale={currentLanguage === 'fi' ? 'fi' : 'en'}
                    placeholderText="DD.MM.YYYY"
                    popperClassName="app-date-picker-popper"
                    portalId="app-date-picker-portal"
                    showPopperArrow={false}
                    required />
                  <span>&mdash;</span>
                  <DatePicker
                    className="app-date-picker-input service-site-width-filter"
                    selected={to || new Date()}
                    onChange={this.handleToChange}
                    dateFormat={['dd.MM.yyyy', 'd.M.yyyy', 'dd.M.yyyy', 'd.MM.yyyy']}
                    strictParsing
                    minDate={from || undefined}
                    maxDate={fromDisable || new Date()}
                    locale={currentLanguage === 'fi' ? 'fi' : 'en'}
                    placeholderText="DD.MM.YYYY"
                    popperClassName="app-date-picker-popper"
                    portalId="app-date-picker-portal"
                    showPopperArrow={false}
                    required />
                  <Button
                    className="filter-button"
                    type="submit"
                    disabled={isDataLoading}>
                    {isDataLoading && (
                      <i className="fa fa-refresh fa-spin" style={{ marginRight: '5px' }} />
                    )}
                    <span>{title}</span>
                  </Button>
                </div>
              </form>
              <p className="timeline-group-text">{translate('service_site.filter_max_months_limitation')}</p>
            </div>
          </div>
          <div className="col-sm-12">
            {this.renderTimeline()}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { serviceSite, serviceSite: { siteInfo, tasks }, destination } = this.props;
    const { activeView, taskToUpdate } = this.state;

    if (!destination || !serviceSite) {
      return <Loader loaded={false} />;
    }

    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="visible-xs-block">
              <Instructions destination={destination} serviceSite={serviceSite} />
            </div>
            <div className="col-sm-6" style={{ width: '60%' }}>
              {activeView === this.VIEW_TYPE.history
                && this.renderHistoryView()}
              {activeView === this.VIEW_TYPE.new_task
                && (
                <ManualTask
                  onSaved={this.onTaskSaved}
                  onCancel={this.changeView(this.VIEW_TYPE.history)}
                  destination={destination}
                  serviceSite={serviceSite} />
                )}
              {activeView === this.VIEW_TYPE.update_task
                && (
                <UpdateTask
                  onSaved={this.onTaskSaved}
                  onCancel={this.clearTaskToUpdate()}
                  task={taskToUpdate} />
                )}
              {activeView === this.VIEW_TYPE.new_issue
                && (
                <ManualIssue
                  onSaved={this.onIssueSaved}
                  onCancel={this.changeView(this.VIEW_TYPE.history)}
                  destination={destination}
                  serviceSite={serviceSite}
                  tasks={tasks} />
                )}
            </div>
            <div className="col-sm-6" style={{ width: '40%' }}>
              <Instructions className="hidden-xs" destination={destination} serviceSite={serviceSite} instructions={siteInfo} />
              <Instructions className="visible-xs-block" instructions={siteInfo} />
            </div>
          </div>
        </div>

        {this.renderModal()}
        {this.renderInstallDocModal()}

      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceSiteId, destinationId } = ownProps.params || {};
  const { serviceSiteMap: { [serviceSiteId]: serviceSite = {} } = {} } = state.destination || {};
  const { destinationMap: { [destinationId]: destination } = {} } = state.destination || {};

  return {
    serviceSiteId,
    destinationId,
    serviceSite,
    destination,
    translate: getTranslate(state?.locale || {}),
    currentLanguage: getActiveLanguage(state?.locale || {})?.code || 'fi',
    session: state.session.session || {},
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  enableSubNavbar,
  setSubNavbar,
  requestServiceSite,
  requestAckIssue,
}, dispatch);

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params} />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ServiceSite));
